<template>
  <div class="register-container">
    <Personal action="register" ref="personal">
      <template #header>
        <header class="title">用户注册</header>
      </template>
      <template #footer="{ user }">
        <div class="input-container">
          <button class="register-btn" @click="registerUser(user)">注册</button>
        </div>
        <div class="input-container">
          <a class="tip" href="/">已有账号，立即登录</a>
        </div>
      </template>
    </Personal>
  </div>
</template>
<script>
import Personal from "@/components/Personal";
import { fetchUserRegister } from "@/api/user";
import { setToken } from "@/utils/auth";
import { mapMutations } from "vuex";
import todoMixin from "@/mixins/todoMixin";
export default {
  name: "Register",
  data() {
    return {
      role: "",
      platform: "",
    };
  },
  mixins: [todoMixin],
  components: {
    Personal,
  },
  created() {
    const { role = "", platform = "" } = this.$route.query;
    this.role = role;
    this.platform = platform;
  },
  methods: {
    ...mapMutations("user", ["SET_DATA"]),
    async registerUser(user) {
      console.log(user,'user');
      let validStatus = this.$refs.personal.checkSubmitParams(user);

      if (validStatus) {
        const params = {
          avatar: user.avatar,
          name: user.userName,
          id_card: user.IDCardNo,
          phone: user.phone,
          email: user.email,
          // code: user.msgCode,
          password: user.password,
          hospital_name: user.hospital,
          department_name: user.department,
          platform: this.platform,
          role: this.role,
          career_name: user.career_name,
          category: user.category,
          position: user.position,
          province_code: this.$refs.personal?.selectHospitalInfo.province_code,
          city_code: this.$refs.personal?.selectHospitalInfo.city_code,
          company_code: this.$refs.personal?.selectHospitalInfo.name_code
        };
        console.log(params,'params',this.$refs.personal);
        
        // return
        const { code, data, msg } = await fetchUserRegister(params);

        if (code == 0) {
          const {
            do: todo,
            common_token,
            common_user,
            role = "",
            platform = "",
          } = data;
          const { name, hospital_name, avatar } = common_user;
          setToken(common_token);
          this["SET_DATA"]({
            name: name ? name : "",
            phone: user.phone,
            hospital_name: hospital_name ? hospital_name : "",
            avatar: avatar ? avatar : "",
            login_todo: todo,
            common_token,
            role: role,
            platform: platform,
          });

          this.handleTodo(todo, true);
        } else {
          this.$meesage({ message: msg, type: "error" });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
